/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-photo': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g id="icon-photo"><path pid="0" id="Shape" class="st0" d="M12.1 6.3h-.9c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h.9c.3 0 .5.2.5.5-.1.2-.3.5-.5.5zM7.4 2.9H4.7c-.3 0-.5-.2-.5-.5 0-.2.3-.4.5-.4h2.7c.3 0 .5.2.5.5s-.2.4-.5.4zm-3.5.5c.3 0 .5.2.5.5s-.3.5-.5.5h-.4c-.8 0-1.5.7-1.5 1.5v5.5c0 .9.7 1.6 1.5 1.6h9c.8 0 1.5-.7 1.5-1.5V5.9c0-.8-.7-1.5-1.5-1.5H7.4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5.1c1.4 0 2.5 1.1 2.5 2.5v5.5c0 1.4-1.1 2.5-2.5 2.5h-9c-1.4.1-2.5-1-2.5-2.4V5.9c0-1.4 1.1-2.5 2.5-2.5h.4zm5.3 5.3c0 1.1-.9 2.1-2.1 2.1S5 9.9 5 8.7s1-2.1 2.1-2.1 2.1 1 2.1 2.1zm-5.1 0c0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3c-1.6 0-3 1.4-3 3z"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/icon-photo.js